import './listing-marker.css';
import React, { useCallback, useMemo } from 'react';
import { Marker } from '@react-google-maps/api';
import { IListing } from '../../models/listing.model';
import { convertToInternationalCurrencySystem } from '../../util/format-number';
import { markerIcon } from '../../util/google.constants';

export interface ListingMarkerProps {
  children?: React.ReactNode;
  listing: IListing;
  zoomLevel: number;
  zIndex: number;
  fillColor?: string;
  isActive: boolean;
  openListing(listing: IListing): void;
  setActivePreviewListingId(value: string): void;
  onMouseOver(listingId: string): void;
  onMouseOut(): void;
}

export const ListingMarker: React.FC<ListingMarkerProps> = props => {

  const onClick = useCallback(function () {
    props.isActive
      ? props.openListing(props.listing)
      : props.onMouseOver(props.listing.id)
      ;
  }, [props]);

  const zIndex = useMemo(() => props.isActive ? 8999 : props.zIndex ? props.zIndex : 8998, [props.isActive, props.zIndex]);

  const icon = useMemo(() => props.isActive ? markerIcon({ fillColor: 'blue', strokeColor: 'white' }) : markerIcon({ fillColor: props.fillColor ? props.fillColor : '#000000', strokeColor: 'white' }), [props.fillColor, props.isActive]);

  const label = useMemo(() => props.zoomLevel > 11 ? { className: 'listing-marker-label', text: convertToInternationalCurrencySystem(props.listing.price) } : undefined, [props.listing.price, props.zoomLevel]);

  const onMouseOver = useCallback(function () {
    props.onMouseOver(props.listing.id);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Marker
      position={{
        lat: props.listing.coords.lat,
        lng: props.listing.coords.lng
      }}
      onMouseOver={onMouseOver}
      onMouseOut={props.onMouseOut}
      clickable
      label={label}
      onClick={onClick}
      zIndex={zIndex}
      icon={icon}
    >
      {props.children}
    </Marker>
  );
}

export default ListingMarker;